module.exports = __webpack_public_path__ + "static/media/YM44_5.2e3a333a.jpg";